<template>
<div class="chapter">
<div class="inner_page">
<a id="pvi"></a><a id="pvii"></a>
<blockquote class="sink"><p class="left ">“The wrongs which we seek to condemn and punish have been so calculated, so malignant, and so devastating, that civilization cannot tolerate their being ignored, because it cannot survive their being repeated.”</p>
<p class="right ">—<em>Robert H. Jackson, Nuremberg prosecutor (1945)</em></p></blockquote>
<div class="timebreak "> </div>
<blockquote><p class="left ">“It is all forgotten. It’s all over.”</p>
<p class="right ">—<em>Jakob Reimer, former Nazi SS officer living outside New York City (1998)</em></p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?8a19f9f4